import React, { Fragment } from 'react';
import { Input, Label } from 'reactstrap';
import { ErrorMessage } from 'formik';

const CustomInput = (field, props, touched, errors) => (
    <Input lang={'de-DE'} {...field} {...props} valid={!!touched[field.name] && !errors[field.name]}
        invalid={!!touched[field.name] && !!errors[field.name]} />
);


export const CustomField = (
    { field, form: { touched, errors }, ...props }
) =>
    <Fragment>
        <Label className={props.type === 'checkbox' ? 'checkbox' : ''}>
            {props.type !== 'checkbox' ? props.label : ''}
            {
                props.type === 'checkbox' &&
                <Fragment>
                    {CustomInput(field, props, touched, errors)}
                    {props.label}
                </Fragment>

            }
        </Label>
        {
            props.type !== 'checkbox' &&
            CustomInput(field, props, touched, errors)
        }
        <div className='invalid-feedback'>
            <ErrorMessage name={field.name} />
        </div>
    </Fragment>;